import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as me from '../../../../me'
import * as routeBound from '../../../../route-bound'
import * as clusters from '../../clusters'
import * as occupants from '../../occupants'

import { Api } from './api.service'
import associations from './associations'
import {
  addOccupantsWithResponsiblePersons,
  reloadResponsiblePersonsOnUpdate,
} from './effects'
import type { TypeParams } from './types'

// TODO: - Maybe we should move this constant to a better place
const IS_PRIMARY_ATTRIBUTE_ID = 'isPrimary'

/** Responsible persons collection for fetching space cluster responsible persons */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams, typeof associations> {
  constructor() {
    const scenarioContext = ngCore.inject(routeBound.scenario.Context.TOKEN)
    const clustersEc = ngCore.inject(clusters.Collection)

    super({
      api: ngCore.inject(Api),
      associations,
      context$: rxjs
        .combineLatest([
          scenarioContext,
          clustersEc.plugins.currentEntityPlugin.feature.selectors.getId()
            .asObservable,
        ])
        .pipe(
          rxjs.map(([context, clusterId]) => {
            if (!context || !ents.extra.space.Cluster.Id.isId(clusterId)) {
              return undefined
            }

            return { ...context, clusterId }
          }),
        ),
      identify: responsiblePerson => responsiblePerson.employee.id,
      name: ec.Name.Predefined.SpaceClusterResponsiblePerson,
      plugins: {
        additionalFactories: [
          new ds.table.ec.Factory<TypeParams>(collection => ({
            cellConfig: ({ entity: person, attribute }) =>
              attribute.id === IS_PRIMARY_ATTRIBUTE_ID
                ? {
                    onClick: () =>
                      collection.plugins.editingPlugin.feature.actions.edit
                        .from('ResponsiblePersons.SetPrimary.Clicked')
                        .dispatch({
                          edit: {
                            input: {
                              isPrimary: !person.isPrimary,
                            },
                          },
                          id: person.employee.id,
                        }),
                  }
                : undefined,
            rowConfig: ({ entity: person }) => ({
              iconsConfigs: [
                {
                  class: 'atn-icon atn-trash atn-red',
                  onClick: () => {
                    collection.plugins.editingPlugin.feature.actions.markForDeletion
                      .from('ResponsiblePersons.Remove.Clicked')
                      .dispatch({ id: person.employee.id })
                  },
                },
              ],
            }),
          })),
        ],
      },
    })

    const occupantsEc = ngCore.inject(occupants.clusterOccupants.Collection)
    this.feature.registerEffects(
      addOccupantsWithResponsiblePersons(this, occupantsEc),
      reloadResponsiblePersonsOnUpdate(this),
    )
  }
}
